import {
  SettingOutlined,
  UserOutlined,
  ClusterOutlined,
  SisternodeOutlined,
  TransactionOutlined
} from '@ant-design/icons';
import Branches from '@pages/DataManagement/Branchs';
import CustomersOrAgencies from '@pages/DataManagement/Customers';
import DelegationGroup from '@pages/DataManagement/DelegationGroup';
import PrintedTemplates from '@pages/DataManagement/PrintedTemplates';
import Providers from '@pages/DataManagement/Providers';
import Staffs from '@pages/DataManagement/Staffs';
import Stocks from '@pages/DataManagement/Stocks';
import Home from '@pages/Home';
import Operating from '@pages/Operating';
import CreateOrders from '@pages/OrganizedSales/CreateOrders';
import Insurance from '@pages/OrganizedSales/Insurance';
import OrderList from '@pages/OrganizedSales/OrderManager';
import OrderReturn from '@pages/OrganizedSales/OrderReturn';
import ReportActionHistory from '@pages/Report/ReportActionHistory';
import ReportByCustomerAndAgency from '@pages/Report/ReportByCustomerAndAgency';
import ReportByOrder from '@pages/Report/ReportByOrder';
import ReportBySellStaff from '@pages/Report/ReportBySellStaff';
import ReportByError from '@pages/Report/ReportByError';
import OrderList2 from '@pages/OrganizedSales/ReportOrderManager';
import ReportInOutStock from '@pages/Report/ReportInOutStock';
import CalculateBuyPrice from '@pages/StockManagment/Statiscal/CalculateBuyPrice';
import InventoryAndAdjustion from '@pages/StockManagment/Statiscal/InventoryAndAdjustion';
import ProductList from '@pages/StockManagment/Production/ProductList';
// import StockMoveCheck from '@pages/StockManagment/StockMove';
import ProductManagement from '@pages/StockManagment/ProductManagement';
import TickerManager from '@pages/CSKHManagment/TickerManager';
import TicketConfig from '@pages/CSKHManagment/TicketConfig';
import PutInStockListKT from '@pages/StockManagment/StockKT/PutInStockListKT';
import GetOutStockListKT from '@pages/StockManagment/StockKT/GetOutStockListKT';
import PutInStockList from '@pages/StockManagment/StockTP/PutInStockList';
import GetOutStockList from '@pages/StockManagment/StockTP/GetOutStockList';
import purchaseCheckList from '@pages/StockManagment/StockSX/purchaseCheckList';
import paymentCheckList from '@pages/StockManagment/StockSX/paymentCheckList';
import AccountManager from '@pages/Administrator/AccountManager';
import TechnicianZone from '@pages/DataManagement/TechnicianZone';
import ProductMix from '@pages/StockManagment/ProductMix/ProductMix';
import StockTechnician from '@pages/StockManagment/StockTechnician/Technician';
import WalletTechinician from '@pages/StockManagment/StockTechnician/WalletTechinician';
import Redirect from '@pages/Redirect';
import UserInfo from '@pages/User/Information/UserInfo';
import ViewLog from '@pages/Administrator/ViewLog';
import {
  IconDataManager,
  IconRiGitRepository,
  IconStock,
  IconCartSale,
  IconCustomer,
  IconZoneTech
} from '@components/StyledComponent';
import { IoDuplicate, IoHeadsetOutline, IoMap, IoNewspaper, IoSettingsOutline, IoTicketOutline } from 'react-icons/io5';
import {
  MdAccountBox,
  MdAttachMoney,
  MdErrorOutline,
  MdManageSearch,
  MdOutlineAssignmentReturn,
  MdOutlineWidgets,
  MdPaid,
  MdSpaceDashboard
} from 'react-icons/md';
import { FaWpforms, FaSimCard, FaFileInvoice, FaFileInvoiceDollar, FaChartLine } from 'react-icons/fa';
import { BsFillBagPlusFill } from 'react-icons/bs';
import ReportByTechStaff from '@pages/Report/ReportByTechStaff';
import ReportByCareStaff from '@pages/Report/ReportByCareStaff';
import ReportByStockStaff from '@pages/Report/ReportByStockStaff';
import OMConfig from '@pages/Administrator/OMConfig';
// import SupportTicket from '@pages/Administrator/SupportTicket';
import ReportByAccountant from '@pages/Report/ReportByAccountant';
import ReportByAccountantV2 from '@pages/Report/ReportByAccountantV2';
import ReportByCareStaffV2 from '@pages/Report/ReportByCareStaffV2';
import ReportBySellStaffV2 from '@pages/Report/ReportBySellStaffV2';
import ReportDetailsSellStaff from '@pages/Report/ReportBySellDetailsStaff';
import ReportByOrderV2 from '@pages/Report/ReportByOrderV2';
import ThongKeHetPhi from '@pages/Report/ThongKeHetPhi';
import reportByOrderV2Old from '@pages/Report/ReportByOrderV2/reportByOrderV2Old';
import ReportByAccountsPayable from '@pages/Report/ReportByAccountsPayable';
import ReportByTechStaffV2 from '@pages/Report/ReportByTechStaffV2';
import ReportByOperatorStaff from '@pages/Report/ReportByOperatorStaff';
import ReportByStockStaffV2 from '@pages/Report/ReportByStockStaffV2';
import ChangeStatusOrder from '@pages/Administrator/ChangeStatusOrder';
import Reflect from '@pages/Administrator/Reflect/Reflect';
import ErrorManagement from '@pages/StockManagment/ErrorManagement';
import Reflect2 from '@pages/Administrator/Reflect/Reflect2';
import ReportBySim from '@pages/Report/ReportBySim/ReportBySim';
import ReportDoanhThu from '@pages/Report/ReportDoanhThu/index';
import ReportDoanhThuV2 from '@pages/Report/ReportDoanhThuV2/index';
import ReportChiTietDoanhThuKD from '@pages/Report/ReportChiTietDoanhThuKD/index';
import FeeTracking from '@pages/Administrator/FeeTracking';
import EndMonth from '@pages/Administrator/EndMonth';
import { AiOutlineFileText } from 'react-icons/ai';
import Invoices from '@pages/DataManagement/Invoices';
import AdjustmentVoucherManager from '@pages/OrganizedSales/AdjustmentVoucher/AdjustmentVoucherManager';
import ReturnProducts from '@pages/StockManagment/ReturnProduct/ReturnProduct';
import ReportDoanhThuKD from '@pages/Report/ReportDoanhThuKD/ReportDoanhThuKD';
import ReportByOrderV3 from '@pages/Report/ReportByOrderV2/reportByOrderV3';

export type RouteProps = {
  key: string;
  title: string;
  children?: RouteProps[];
  url?: string;
  Icon?: any;
  Component?: any;
  disabled?: boolean;
  exact?: boolean;
  dividerLine?: boolean;
  level?: number;
  hiddenSider?: boolean; // ẩn menu khỏi sider bar
  RoleAccepts?: any[]; // không đặt role thì có quyền xem, đặt role rỗng là không có quyền xem menu đó
  onlyHead?: any[] | undefined; // không đặt onlyHead thì có quyền xem, đặt thì rỗng chặn hết còn đặt role nào thì chỉ role đó được xem
  UserAccepts?: string[]; // username được xem dù không đủ role
  UserAcceptsKey?: string; // key config chứa danh sách username, cách nhau bởi dấu phẩy
};

export const routes: RouteProps[] = [
  {
    key: 'dashboard-page',
    title: 'Menu.Dashboard',
    Icon: MdSpaceDashboard,
    url: '/dashboard',
    exact: true,
    Component: Home,
    RoleAccepts: ['Admin', 'Root', 'BranchManager']
  },
  {
    key: 'operating-page',
    title: 'Menu.Operating',
    url: '/operating',
    exact: true,
    Icon: IoMap,
    Component: Operating,
    RoleAccepts: []
  },
  {
    key: 'data-management',
    title: 'Menu.DataManagement.Title',
    exact: true,
    Icon: IconDataManager,
    RoleAccepts: ['Sale', 'CustomerService', 'Accountant', 'BranchManager', 'Operating', 'Admin', 'Root'],
    children: [
      {
        key: 'data-management.branch-page',
        title: 'Menu.DataManagement.Branch',
        url: '/chi-nhanh',
        exact: true,
        Component: Branches,
        Icon: SisternodeOutlined,
        RoleAccepts: ['Admin', 'Root']
        // 'Sale', 'CustomerService', 'Accountant', 'BranchManager',
      },
      {
        key: 'data-management.technician-page',
        title: 'Menu.DataManagement.TechnicianZone',
        url: '/vung-ky-thuat',
        exact: true,
        Component: TechnicianZone,
        Icon: IconZoneTech,
        RoleAccepts: ['Operating', 'Admin', 'Root']
        // 'Sale', 'CustomerService', 'Accountant', 'BranchManager',
      },
      {
        key: 'data-management.customersoragencies-page',
        title: 'Menu.DataManagement.CustomersOrAgencies',
        url: '/khach-hang-dai-ly',
        exact: true,
        Component: CustomersOrAgencies,
        Icon: IconCustomer,
        RoleAccepts: ['Sale', 'CustomerService', 'Accountant', 'BranchManager', 'Admin', 'Root']
      },
      {
        key: 'data-management.voices-page',
        title: 'Menu.DataManagement.Voices',
        url: '/quan-ly-hoa-don',
        exact: true,
        Component: Invoices,
        Icon: FaFileInvoice,
        RoleAccepts: ['Accountant', 'BranchManager', 'Admin', 'Root'],
        // UserAccepts: ['kkt.ktohcm'],
        UserAcceptsKey: 'UserAccountTax',
        dividerLine: true
      },
      //  {
      //   key: 'data-management.balanceordebts-page',
      //   title: 'Menu.DataManagement.BalanceOrDebts',
      //   url: '/cong-du-no-khach-hang',
      //   exact: true,
      //   Component: BalanceDebts,
      //   Icon: TransactionOutlined,
      //   RoleAccepts: ['Sale', 'CustomerService', 'Accountant', 'BranchManager', 'Admin', 'Root'],
      //   dividerLine: true
      // },
      // divider line
      {
        key: 'data-management.providers-page',
        title: 'Menu.DataManagement.Providers',
        url: '/nha-cung-cap',
        exact: true,
        Component: Providers,
        RoleAccepts: []
      },
      {
        key: 'data-management.stocks-page',
        title: 'Menu.DataManagement.Stocks',
        url: '/kho',
        exact: true,
        Component: Stocks,
        RoleAccepts: []
      },
      // {
      //   key: 'data-management.printedtemplates-page',
      //   title: 'Menu.DataManagement.PrintedTemplates',
      //   url: '/quan-ly-mau-in',
      //   exact: true,
      //   Component: PrintedTemplates
      // }
      {
        key: 'data-management.ticket-config',
        title: 'Menu.CSKHManagement.TitleConfig',
        url: '/cau-hinh-ho-tro',
        exact: true,
        Component: TicketConfig,
        Icon: IoSettingsOutline,
        RoleAccepts: ['Admin', 'Root', 'CustomerService'] // , 'CustomerService'
      }
    ]
  },
  {
    key: 'organized-sales',
    title: 'Menu.OrganizedSales.Title',
    exact: true,
    Icon: IconCartSale,
    RoleAccepts: ['Sale', 'CustomerService', 'Accountant', 'Operating', 'Technician', 'BranchManager', 'Admin', 'Root'],
    children: [
      {
        key: 'organized-sales.createorders-page',
        title: 'Menu.OrganizedSales.CreateOrders',
        url: '/tao-don-hang',
        exact: true,
        Component: CreateOrders,
        Icon: BsFillBagPlusFill,
        RoleAccepts: ['Sale', 'CustomerService', 'Root', 'Accountant'] //  Technician 'Admin',
      },
      {
        key: 'organized-sales.ordermanager-page',
        title: 'Menu.OrganizedSales.OrderManager',
        url: '/quan-ly-don-hang',
        exact: true,
        Component: OrderList,
        Icon: ClusterOutlined,
        dividerLine: true,
        RoleAccepts: [
          'Sale',
          'CustomerService',
          'Accountant',
          'Operating',
          'Technician',
          'BranchManager',
          'Admin',
          'Root'
        ]
      },
      // {
      //   key: 'organized-sales.adjustment-voucher-manager-page',
      //   title: 'Menu.OrganizedSales.AdjustmentVoucherManager',
      //   url: '/quan-ly-phieu-dieu-chinh',
      //   exact: true,
      //   Component: AdjustmentVoucherManager,
      //   Icon: ClusterOutlined,
      //   // dividerLine: true,
      //   RoleAccepts: [
      //     'Sale',
      //     'CustomerService',
      //     'Accountant',
      //     'Operating',
      //     'Technician',
      //     'BranchManager',
      //     'Admin',
      //     'Root'
      //   ]
      // },
      {
        key: 'organized-sales.orderreturn-page',
        title: 'Menu.OrganizedSales.OrderReturn',
        url: '/khach-tra-hang',
        exact: true,
        Component: OrderReturn,
        RoleAccepts: []
      },
      {
        key: 'organized-sales.insurance-page',
        title: 'Menu.OrganizedSales.Insurance',
        url: '/bao-hanh',
        exact: true,
        Component: Insurance,
        dividerLine: true,
        RoleAccepts: []
      }
      // divider line
      // {
      //    key: 'organized-sales.create-orders',
      //   title: 'Menu.OrganizedSales.',
      //   url: '/mua-hang',
      //   // Component:
      // },
    ]
  },
  {
    key: 'cskh-management',
    title: 'Menu.CSKHManagement.Title',
    exact: true,
    Icon: IoHeadsetOutline, // 🎧 Thay IconStock bằng icon Tai nghe hỗ trợ
    // 'Admin','Root','Operating',
    RoleAccepts: [
      // 'Sale',
      'CustomerService',
      // 'BranchManager',
      'Admin',
      'Root'
      // 'WareHouse'
    ],
    children: [
      {
        key: 'cskh-management.cskh-management',
        title: 'Menu.CSKHManagement.TitleTicket',
        url: '/quan-ly-phieu',
        exact: true,
        Component: TickerManager,
        Icon: IoTicketOutline, // 🎫 Thay IoDuplicate bằng icon Ticket (Phiếu)
        RoleAccepts: ['Admin', 'Root', 'CustomerService'] // 'CustomerService', 'BranchManager'
      },
      // Đưa từ nhóm top-level cũ (support.thong-ke-xe-het-phi) vào đây theo yêu cầu gộp chung mảng CSKH
      {
        key: 'cskh-management.thong-ke-xe-het-phi',
        title: 'Menu.Support.ThongKeHetPhi',
        url: '/thong-ke-het-phi',
        exact: true,
        Component: ThongKeHetPhi,
        Icon: FaWpforms,
        RoleAccepts: ['Admin', 'Root'], // , 'CustomerService'
        // UserAccepts: ['uyen.cskh', 'hoaiduyen.cskh']
        UserAcceptsKey: 'ViewMenuThongKe'
      }
    ]
  },
  {
    key: 'stock-management',
    title: 'Menu.StockManagement.Title',
    exact: true,
    Icon: IconStock,
    // 'Admin','Root','Operating',
    RoleAccepts: [
      // 'Sale',
      // 'CustomerService',
      'Accountant',
      'Operating',
      'Technician',
      'BranchManager',
      'Admin',
      'Root'
      // 'WareHouse'
    ],
    // 'Sale', 'CustomerService', 'Accountant', 'BranchManager',
    children: [
      {
        key: 'stock-management.product-management',
        title: 'Menu.StockManagement.ProductManagement',
        url: '/quan-ly-thong-tin-san-pham',
        exact: true,
        Component: ProductManagement,
        Icon: IoDuplicate,
        RoleAccepts: ['BranchManager', 'Admin', 'Root'] // 'Sale', 'CustomerService', 'Accountant',
      },
      {
        key: 'stock-management.error-management',
        title: 'Menu.StockManagement.ErrorManagement',
        url: '/quan-ly-loi-san-pham',
        exact: true,
        Component: ErrorManagement,
        Icon: MdErrorOutline,
        RoleAccepts: ['BranchManager', 'Admin', 'Root', 'Operating'] // 'Sale', 'CustomerService', 'Accountant',
      },
      // {
      //   key: 'stock-management.product-mix',
      //   title: 'Menu.StockManagement.ProductMix',
      //   url: '/danh-muc-san-pham',
      //   exact: true,
      //   Component: ProductMix,
      //   Icon: MdOutlineWidgets,
      //   RoleAccepts: ['BranchManager', 'Admin', 'Root'] // 'Sale', 'CustomerService', 'Accountant',
      // },
      {
        key: 'stock-management.kho-ky-thuat',
        title: 'Menu.StockManagement.StockTechnician',
        url: '/kho-ky-thuat',
        exact: true,
        Component: StockTechnician,
        Icon: MdOutlineWidgets,
        // 'Sale', 'CustomerService', 'Accountant', 'BranchManager', 'Admin', 'Root'
        RoleAccepts: ['Technician', 'BranchManager', 'Admin', 'Root']
      },
      {
        key: 'stock-management.return-product',
        title: 'Menu.StockManagement.ReturnProduct',
        url: '/tra-hang',
        exact: true,
        Component: ReturnProducts,
        Icon: MdOutlineAssignmentReturn,
        dividerLine: true,
        RoleAccepts: ['Root', 'Admin', 'Accountant'],
        UserAcceptsKey: 'UseManageReturnProduct'
      },
      {
        key: 'stock-management.product-list',
        title: 'Menu.StockManagement.ProductList',
        url: '/san-pham',
        exact: true,
        Component: ProductList,
        dividerLine: true,
        RoleAccepts: []
      },
      // divider line
      {
        key: 'stock-management.product-putin',
        title: 'Menu.StockManagement.PutInStock',
        url: '/nhap-kho-ky-thuat',
        exact: true,
        Component: PutInStockListKT,
        RoleAccepts: []
      },
      {
        key: 'stock-management.product-putout',
        title: 'Menu.StockManagement.PutOutStock',
        url: '/xuat-kho-ky-thuat',
        exact: true,
        Component: GetOutStockListKT,
        dividerLine: true,
        RoleAccepts: []
      },
      // divider line
      {
        key: 'stock-management.inventory-and-adjustion',
        title: 'Menu.StockManagement.InventoryAndAdjustion',
        url: '/kiem-ke-dieu-chinh',
        exact: true,
        Component: InventoryAndAdjustion,
        RoleAccepts: []
      },
      {
        key: 'stock-management.calculate-buy-price',
        title: 'Menu.StockManagement.CalculateBuyPrice',
        url: '/tinh-gia-xuat-kho',
        exact: true,
        Component: CalculateBuyPrice,
        dividerLine: true,
        RoleAccepts: []
      },
      // divider line
      {
        key: 'stock-management.put-in-stock-list',
        title: 'Menu.StockManagement.PutInStockList',
        url: '/nhap-kho-thanh-pham',
        exact: true,
        Component: PutInStockList,
        RoleAccepts: []
      },
      {
        key: 'stock-management.put-out-stock-list',
        title: 'Menu.StockManagement.PutOutStockList',
        url: '/xuat-kho-thanh-pham',
        exact: true,
        Component: GetOutStockList,
        dividerLine: true,
        RoleAccepts: []
      },
      // divider line
      {
        key: 'stock-management.purchase-check',
        title: 'Menu.StockManagement.PurchaseCheck',
        url: '/phieu-mua-hang',
        exact: true,
        Component: purchaseCheckList,
        RoleAccepts: []
      },
      {
        key: 'stock-management.payment-check',
        title: 'Menu.StockManagement.PaymentCheck',
        url: '/phieu-chi',
        exact: true,
        Component: paymentCheckList,
        dividerLine: true,
        RoleAccepts: []
      }

      // divider line
      // {
      //   key: uuid(),
      //   title: 'Menu.StockManagement.StockMoveCheck',
      //   url: '/danh-sach-chuyen-kho',
      //   Component: StockMoveCheck,
      // },
      // {
      //   key: uuid(),
      //   title: 'Menu.StockManagement.InventoryCheck',
      //   url: '/danh-sach-phieu-kiem-ke',
      //   Component: InventoryCheck,
      // },
    ]
  },
  {
    key: 'money-management',
    title: 'Menu.MoneyManager.Title',
    exact: true,
    Icon: MdPaid,
    // onlyHead: ['Accountant', 'Operating'],
    // RoleAccepts: ['Sale', 'CustomerService', 'Accountant', 'Operating', 'Technician', 'BranchManager', 'Admin', 'Root'],
    onlyHead: ['Admin', 'Root', 'BranchManager'],
    children: [
      {
        key: 'money-management.fee-tracking-page',
        title: 'Menu.Administrator.FeeTracking',
        Icon: MdAttachMoney,
        url: '/theo-doi-thu-tien',
        exact: true,
        Component: FeeTracking,
        onlyHead: ['Admin', 'Root', 'BranchManager'] // 'Accountant', 'Operating', 'BranchManager', 'Admin', 'Root'
        // RoleAccepts: [
        //   // 'Sale',
        //   // 'CustomerService',
        //   // 'Accountant',
        //   // 'Operating',
        //   // 'Technician',
        //   'BranchManager',
        //   'Admin',
        //   'Root'
        // ]
      }
      // {
      //   key: 'money-management.end-month',
      //   title: 'Menu.Administrator.EndMonth',
      //   Icon: MdAttachMoney,
      //   url: '/chot-thang',
      //   exact: true,
      //   Component: EndMonth,
      //   RoleAccepts: ['Accountant', 'BranchManager', 'Admin', 'Root']
      // }
    ]
  },
  {
    key: 'report-statistic',
    title: 'Menu.ReportStatistic.Title',
    Icon: IconRiGitRepository,
    exact: true,
    children: [
      // {
      //   key: 'report-statistic.report-by-accounts-payable',
      //   title: 'Menu.ReportStatistic.ReportByAccountsPayable',
      //   url: '/bao-cao-chi-tiet-cong-no',
      //   exact: true,
      //   Component: ReportByAccountsPayable,
      //   Icon: FaFileInvoiceDollar,
      //   RoleAccepts: ['Accountant', 'BranchManager', 'Admin', 'Root']
      // },
      {
        key: 'report-statistic.report-by-order',
        title: 'Menu.ReportStatistic.ReportByDetailsOrder',
        url: '/bao-cao-chi-tiet-don-hang',
        exact: true,
        Component: ReportByOrderV3,
        Icon: FaWpforms
        // RoleAccepts: ['Admin','Root']
      },
      // {
      //   key: 'report-statistic.report-by-order-old',
      //   title: 'Menu.ReportStatistic.ReportByDetailsOrderOld',
      //   url: '/bao-cao-chi-tiet-don-hang-old',
      //   exact: true,
      //   Component: reportByOrderV2Old,
      //   Icon: FaWpforms
      //   // RoleAccepts: ['Admin','Root']
      // },
      {
        key: 'report-statistic.ordermanager-page2',
        title: 'Menu.ReportStatistic.ReportByOrder',
        url: '/bao-cao-theo-don-hang',
        exact: true,
        Component: OrderList2,
        Icon: ClusterOutlined,
        dividerLine: true,
        RoleAccepts: [
          'Sale',
          'CustomerService',
          'Accountant',
          'Operating',
          'Technician',
          'BranchManager',
          'Admin',
          'Root',
          'WareHouse'
        ]
      },
      // {
      //   key: 'report-statistic.report-by-customer-and-agency',
      //   title: 'Menu.ReportStatistic.ReportByCustomerAndAgency',
      //   url: '/bao-cao-theo-khach-hang-dai-ly',
      //   exact: true,
      //   Component: ReportByCustomerAndAgency,
      //   dividerLine: true,
      //   RoleAccepts: []
      // },
      // divider line
      {
        key: 'report-statistic.report-by-sell-staff',
        title: 'Menu.ReportStatistic.TitleReportBySellStaff',
        url: '/bao-cao-theo-kinh-doanh',
        exact: true,
        Icon: IoNewspaper,
        Component: ReportBySellStaff,
        RoleAccepts: ['Admin', 'Root', 'Sale', 'BranchManager'] // 'Accountant'
      },
      {
        key: 'report-statistic.report-by-operator',
        title: 'Menu.ReportStatistic.ReportByStaffOperator',
        url: '/bao-cao-theo-dieu-hanh',
        exact: true,
        Component: ReportByOperatorStaff,
        // dividerLine: true,
        Icon: IoNewspaper,
        RoleAccepts: ['Admin', 'Root', 'BranchManager', 'Operating'] // , 'Technician'
      },
      // {
      //   key: 'report-statistic.report-by-staff-tech',
      //   title: 'Menu.ReportStatistic.ReportByStaffTech',
      //   url: '/bao-cao-theo-ky-thuat',
      //   exact: true,
      //   Component: ReportByTechStaff,
      //   // dividerLine: true,
      //   Icon: IoNewspaper,
      //   RoleAccepts: ['Admin', 'Root', 'BranchManager', 'Operating'] // , 'Technician'
      // },
      {
        key: 'report-statistic.report-by-staff-tech',
        title: 'Menu.ReportStatistic.ReportByStaffTech',
        url: '/bao-cao-theo-ky-thuat',
        exact: true,
        Component: ReportByTechStaffV2,
        // dividerLine: true,
        Icon: IoNewspaper,
        RoleAccepts: ['Admin', 'Root', 'BranchManager', 'Operating'] // , 'Technician'
      },
      // {
      //   key: 'report-statistic.report-inout-stock',
      //   title: 'Menu.ReportStatistic.ReportByStockStaff',
      //   url: '/bao-cao-theo-kho',
      //   exact: true,
      //   Icon: IoNewspaper,
      //   Component: ReportByStockStaff,
      //   RoleAccepts: ['Admin', 'Root', 'WareHouse', 'BranchManager']
      // },
      {
        key: 'report-statistic.report-inout-stock',
        title: 'Menu.ReportStatistic.ReportByStockStaff',
        url: '/bao-cao-theo-kho',
        exact: true,
        Icon: IoNewspaper,
        Component: ReportByStockStaffV2,
        RoleAccepts: ['Admin', 'Root', 'WareHouse', 'BranchManager', 'Operating']
      },
      // divider line
      // {
      //   key: 'report-statistic.report-by-care-staff',
      //   title: 'Menu.ReportStatistic.ReportByCareStaff',
      //   url: '/bao-cao-theo-cskh',
      //   exact: true,
      //   Component: ReportByCareStaff,
      //   Icon: IoNewspaper,
      //   RoleAccepts: ['Admin', 'Root', 'CustomerService', 'BranchManager']
      // },
      {
        key: 'report-statistic.report-by-care-staff',
        title: 'Menu.ReportStatistic.ReportByCareStaff',
        url: '/bao-cao-theo-cskh',
        exact: true,
        Component: ReportByCareStaffV2,
        Icon: IoNewspaper,
        RoleAccepts: ['Admin', 'Root', 'CustomerService', 'BranchManager']
      },
      // {
      //   key: 'report-statistic.report-by-accountant',
      //   title: 'Menu.ReportStatistic.ReportByAccountant',
      //   url: '/bao-cao-theo-ke-toan',
      //   exact: true,
      //   Component: ReportByAccountant,
      //   Icon: IoNewspaper,
      //   RoleAccepts: ['Admin', 'Root', 'Accountant']
      // },
      {
        key: 'report-statistic.report-by-accountant',
        title: 'Menu.ReportStatistic.ReportByAccountant',
        url: '/bao-cao-theo-ke-toan',
        exact: true,
        Component: ReportByAccountantV2,
        Icon: IoNewspaper,
        RoleAccepts: ['Admin', 'Root', 'Accountant']
      },
      {
        key: 'report-statistic.report-by-error',
        title: 'Menu.ReportStatistic.TitleReportByError',
        url: '/bao-cao-thong-ke-loi',
        exact: true,
        Icon: IoNewspaper,
        Component: ReportByError,
        RoleAccepts: ['CustomerService', 'Operating', 'Technician', 'Admin', 'Root', 'BranchManager'], // 'Accountant'
        onlyHead: ['CustomerService', 'Operating', 'Technician', 'Admin', 'Root', 'BranchManager']
      },
      {
        key: 'report-statistic.report-by-sim',
        title: 'Menu.ReportStatistic.TitleReportBySim',
        url: '/bao-cao-thong-ke-sim',
        exact: true,
        Icon: FaSimCard,
        Component: ReportBySim,
        RoleAccepts: ['CustomerService', 'Admin', 'Root'] // 'Accountant' 'Operating', 'Technician',  'Admin', 'Root', 'BranchManager'
        // onlyHead: ['CustomerService', 'Operating', 'Technician', 'Admin', 'Root', 'BranchManager'],
      },
      // {
      //   key: 'report-statistic.report-doanh-thu',
      //   title: 'Menu.ReportStatistic.TitleReportDoanhThu',
      //   url: '/bao-cao-doanh-thu-khach-hang',
      //   exact: true,
      //   Icon: FaSimCard,
      //   Component: ReportDoanhThu,
      //   RoleAccepts: ['Admin', 'Root', 'BranchManager', 'Accountant'] // 'Accountant' 'Operating', 'Technician',  'Admin', 'Root', 'BranchManager'
      //   // onlyHead: ['CustomerService', 'Operating', 'Technician', 'Admin', 'Root', 'BranchManager'],
      // },
      {
        key: 'report-statistic.report-doanh-thu',
        title: 'Menu.ReportStatistic.TitleReportDoanhThu',
        url: '/bao-cao-doanh-thu-khach-hang',
        exact: true,
        Icon: FaFileInvoiceDollar,
        Component: ReportDoanhThuV2,
        RoleAccepts: ['Admin', 'Root', 'BranchManager', 'Accountant'] // 'Accountant' 'Operating', 'Technician',  'Admin', 'Root', 'BranchManager'
        // onlyHead: ['CustomerService', 'Operating', 'Technician', 'Admin', 'Root', 'BranchManager'],
      },
      {
        key: 'report-statistic.report-doanh-thu-KD',
        title: 'Menu.ReportStatistic.TitleReportDoanhThuKD',
        url: '/bao-cao-doanh-thu-theo-kinh-doanh',
        exact: true,
        Icon: FaChartLine,
        Component: ReportDoanhThuKD,
        RoleAccepts: ['Admin', 'Root', 'BranchManager', 'Sale', 'Accountant'] // 'Accountant' 'Operating', 'Technician',  'Admin', 'Root', 'BranchManager'
        // onlyHead: ['CustomerService', 'Operating', 'Technician', 'Admin', 'Root', 'BranchManager'],
      },
      {
        key: 'report-statistic.report-chi-tiet-doanh-thu-KD',
        title: 'Menu.ReportStatistic.TitleReportChiTietDoanhThuKD',
        url: '/bao-cao-chi-tiet-doanh-thu-theo-kinh-doanh',
        exact: true,
        Icon: FaFileInvoiceDollar,
        Component: ReportChiTietDoanhThuKD,
        RoleAccepts: ['Root', 'Admin', 'Accountant'] // 'Admin', 'BranchManager', 'Sale', 'Accountant'
        // UserAccepts: ['minhtrieu.adsun', 'nguyenan.ketoan', 'quocthinh.it', 'vynguyen.ktohcm'],
        // UserAcceptsKey: 'ViewBCChiTietDoanhThu'
      },
      {
        key: 'report-statistic.report-action-history',
        title: 'Menu.ReportStatistic.ReportActionHistory',
        url: '/lich-su-thao-tac',
        exact: true,
        Component: ReportActionHistory,
        RoleAccepts: []
      }
    ]
  },
  // support.thong-ke-xe-het-phi đã chuyển vào nhóm cskh-management (xem trên) theo yêu cầu gộp chung
  {
    key: 'administrator',
    title: 'Menu.Administrator.Title',
    Icon: SettingOutlined,
    exact: true,
    onlyHead: [
      'Sale',
      'CustomerService',
      'Accountant',
      'Operating',
      'Technician',
      'BranchManager',
      'Admin',
      'Root',
      'WareHouse'
    ],
    children: [
      {
        key: 'administrator.account-manager-page',
        title: 'Menu.Administrator.AccountManager',
        Icon: MdAccountBox,
        url: '/quan-ly-tai-khoan',
        exact: true,
        Component: AccountManager,
        onlyHead: [
          'Sale',
          'CustomerService',
          'Accountant',
          'Operating',
          'Technician',
          'BranchManager',
          'Admin',
          'Root',
          'WareHouse'
        ]
      },
      {
        key: 'administrator.log',
        title: 'Menu.Administrator.ViewLog',
        Icon: MdAccountBox,
        url: '/xem-log',
        exact: true,
        Component: ViewLog,
        onlyHead: [
          // 'Sale',
          // 'CustomerService',
          // 'Accountant',
          'Operating',
          // 'Technician',
          // 'BranchManager',
          // 'WareHouse',
          'Admin',
          'Root'
        ]
      },
      {
        key: 'administrator.omconfig',
        title: 'Menu.Administrator.OMConfig',
        Icon: MdAccountBox,
        url: '/OM-Config',
        exact: true,
        Component: OMConfig,
        onlyHead: [
          // 'Sale',
          // 'CustomerService',
          // 'Accountant',
          // 'Operating',
          // 'Technician',
          // 'BranchManager',
          // 'WareHouse',
          // 'Admin',
          'Root'
        ]
      },
      // {
      //   key: 'administrator.support-ticket',
      //   title: 'Menu.Administrator.SupportTicket',
      //   Icon: MdAccountBox,
      //   url: '/ho-tro-khach-hang',
      //   exact: true,
      //   Component: SupportTicket,
      //   onlyHead: [
      //     // 'Sale',
      //     // 'CustomerService',
      //     // 'Accountant',
      //     // 'Operating',
      //     // 'Technician',
      //     // 'BranchManager',
      //     // 'WareHouse',
      //     // 'Admin',
      //     'Root'
      //   ]
      // },
      {
        key: 'administrator.backdoor',
        title: 'Menu.Administrator.BackDoor',
        Icon: MdAccountBox,
        url: '/backdoor',
        exact: true,
        Component: ChangeStatusOrder,
        RoleAccepts: ['Admin', 'Root']
      },
      {
        key: 'administrator.reflect',
        title: 'Menu.Administrator.Reflect',
        Icon: MdAccountBox,
        url: '/reflect',
        exact: true,
        Component: Reflect,
        RoleAccepts: ['Admin', 'Root']
      },
      // {
      //   key: 'administrator.reflect2',
      //   title: 'Menu.Administrator.Reflect',
      //   Icon: MdAccountBox,
      //   url: '/reflect2',
      //   exact: true,
      //   Component: Reflect2,
      //   RoleAccepts: ['Admin', 'Root']
      // },
      {
        key: 'administrator.delegation-group',
        title: 'Menu.DataManagement.DelegationGroup',
        // Icon: UserOutlined,
        url: '/nhom-phan-quyen',
        exact: true,
        Component: DelegationGroup,
        RoleAccepts: []
      },
      {
        key: 'administrator.staffs',
        title: 'Menu.DataManagement.Staffs',
        // Icon: UserOutlined,
        url: '/nhan-vien',
        exact: true,
        Component: Staffs,
        dividerLine: true,
        RoleAccepts: []
      }
    ]
  },
  {
    key: 'redirect',
    title: 'Menu.Control',
    Icon: SettingOutlined,
    url: '/',
    exact: true,
    hiddenSider: true,
    Component: Redirect
  },
  {
    key: 'thong-tin-tai-khoan',
    title: 'Menu.InformationAccount',
    Icon: SettingOutlined,
    url: '/thong-tin-tai-khoan',
    exact: true,
    hiddenSider: true,
    Component: UserInfo
  }
];

export default routes;
